import { Button } from "@mui/material";
import { useSnackbar } from "notistack";

export default function SnackbarAction({ id }) {
  const { closeSnackbar } = useSnackbar();

  return (
    <>
      <Button
        onClick={() => closeSnackbar(id)}
        style={{
          height: "100%",
          left: 0,
          position: "absolute",
          top: 0,
          width: "100%",
          border: "none",
        }}
        variant="text"
      />
    </>
  );
}
